<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Edición ítem</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Edición ítem</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="tpItemForm">
        <div class="container-fluid">
            <div class="row align-items-center">

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.NroLinea}}</mat-label>

                        <input readonly formControlName="nroLinea" type="text" matInput>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.Cantidad}}</mat-label>
                        <input appThreeDigitDecimaNumber formControlName="cantidad" type="text" matInput>
                        <mat-error
                            *ngIf=" !tpItemForm.controls['cantidad'].valid && tpItemForm.get('cantidad').touched">
                            {{Validaciones.Cantidad}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3" *ngIf="avisoUnidadesPallet">

                    <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                        <mat-card-content>

                            <p>{{this.mensajeUnidadesPallet}} </p>

                        </mat-card-content>

                    </mat-card>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdProducto}}</mat-label>
                        <input readonly formControlName="idProducto" type="text" matInput>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Producto}}</mat-label>
                        <input readonly formControlName="producto" type="text" matInput>

                    </mat-form-field>
                </div>


                <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Planta}}</mat-label>
                        <mat-select (selectionChange)='seleccionarPlantaItem($event.value)'
                            [compareWith]="comparePlantas" formControlName="idPlanta">
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let p of plantasItem" [value]="p.idPlanta">{{p.displayValue}}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="(tpItemForm.get('idPlanta').hasError('required')) && tpItemForm.get('idPlanta').touched">
                            {{Validaciones.IdPlanta}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.StorageLocation}}</mat-label>
                        <mat-select (selectionChange)='seleccionarStorageLocation($event.value)'
                            [compareWith]="compareStoragesLocations"
                            formControlName="idUbicacionAlmacenamiento">
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let sl of storagesLocations" [value]="sl.id">{{sl.id}}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="(tpItemForm.get('idUbicacionAlmacenamiento').hasError('required')) && tpItemForm.get('idUbicacionAlmacenamiento').touched">
                            {{Validaciones.StorageLocation}}
                        </mat-error>
                    </mat-form-field>
                </div> -->
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdLote}}</mat-label>
                        <mat-select (selectionChange)='seleccionarLote($event.value)'
                            [compareWith]="compareLotes"
                            formControlName="idLote">
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let l of lotes" [value]="l.value">{{l.value}}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="(tpItemForm.get('idLote').hasError('required')) && tpItemForm.get('idLote').touched">
                            {{Validaciones.IdLote}}
                        </mat-error>
                    </mat-form-field>
                </div>


            </div>
        </div>


    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button (click)="guardarItem()" [disabled]="tpItemForm.invalid" mat-flat-button
        color="accent">Guardar</button>
    <button mat-dialog-close mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>

